var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            ref: "tabs",
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_BranchBill"),
                  name: "branchBill"
                }
              },
              [_c("new-bill-overseas-s-center-view")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Submitted"),
                  name: "submitted"
                }
              },
              [_c("new-bill-overseas-s-submit-view")],
              1
            ),
            _vm.$checkPermission(["tab_BillOverseasSCenter_billOverseasAccept"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_Received"),
                      name: "received"
                    }
                  },
                  [_c("new-bill-overseas-s-accept-view")],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["tab_BillOverseasSCenter_billOverseasMsg"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_SettlementNotice"),
                      name: "settlementNotice"
                    }
                  },
                  [_c("new-bill-actual-amount")],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission([
              "tab_BillOverseasSCenter_billOverseasConfirm"
            ])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_BranchConfirmation"),
                      name: "branchConfirmation"
                    }
                  },
                  [_c("office-confirm-new")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }